export const MAX_IMAGES_FOR_PERIODIC_CHECK = 5;

/** Status of the whole check (`lastDailyCheck.status`), not a checklist line. */
export const PERIODIC_CHECK_DRAFT_STATUS = 3;

/** Checklist line status for I/A. Stored `0` stays "not selected". */
export const PERIODIC_CHECK_ITEM_NOT_APPLICABLE = 3;